const { db } = require("../firebase");
const { collection, setDoc, getDocs, getDoc, addDoc, updateDoc, deleteDoc, doc, where, query, arrayUnion } = require("firebase/firestore");

const usersCollectionRef = collection(db, "Users");

class UserDataService {

    createUser = async (uid, email) => {
        const newUserRef = await setDoc(doc(db, "Users", uid), {
            email: email,
            favorites: []
        });
        return newUserRef;
    };

    getProfile = async (uid) => {
        const userDoc = doc(db, "Users", uid);
        return await getDoc(userDoc);
    }

    addFavorite = async (uid, fav) => {
        const userDoc = doc(db, "Users", uid);
        return await updateDoc(userDoc, {
            favorites: arrayUnion(fav)
        });
    }

}

export const uds = new UserDataService();